import React, { Component } from 'react';
import '../../styles/style.css'
import { Grid, Row, Col } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { connect } from 'react-redux'

import { authActions } from '../../../core/auth'

const styles = {
  spacetop: {
      height: '20px'
  },
}

const validate = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = "Please enter an email.";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address'
  }

  if (!values.password) {
    errors.password = "Please enter a password.";
  }

  if (!values.passwordConfirmation) {
    errors.passwordConfirmation = "Please enter a password confirmation.";
  }

  if (values.password !== values.passwordConfirmation ) {
    errors.password = 'Passwords do not match';
  }

  return errors;
}

class SignUp extends Component {
  handleFormSubmit = (values) => {
    this.props.clickEmailSignUp(values)
  }

  renderField = ({ input, label, type, meta: { touched, error } }) => (
    <fieldset>
      <div>
        <TextField {...input} placeholder={label} type={type}
          errorText={touched && error && <span>{error}</span>}
        />

      </div>
    </fieldset>
  );

  render() {
    return (
      <div>
        <div className="subheader">
          <h4>Sign-Up</h4>
        </div>
        <Grid>
          <Row>
            <Col xs={12} md={8} mdOffset={2}>
                <div style={styles.spacetop}></div>
                <form onSubmit={this.props.handleSubmit(this.handleFormSubmit)}>
                  <Field name="email" type="text" component={this.renderField} label="Email" />
                  <Field name="password" type="password" component={this.renderField} label="Password" />
                  <Field name="passwordConfirmation" type="password" component={this.renderField} label="Password Confirmation" />
                  <RaisedButton type="submit" label="Sign Up" primary={true} />
                </form>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}


export default connect(null, authActions)(reduxForm({
  form: 'sign-up',
  validate
})(SignUp))


// WEBPACK FOOTER //
// ./src/views/pages/sign-up/index.js